<template>
  <div>
    <div v-if="isLoad">
      <div v-if="!detail" class="columns is-multiline">
        <selecteur-action
          @handleAction="handleAction"
          :options="actions"
          :placeholder='$t("general.placeHolder.groupedAction")'
          :elementsSelectionnes="getAllSelected.length > 0"
          titleButton="general.button.apply"
          class="column is-narrow mgb-0">
        </selecteur-action>
        <div class="column has-text-right">
          <a class="button is-addOrEdit" @click="addOrEditLigne()">
            {{ $t('addEditPlanMedia.evenement.actions.add')}}
          </a>
        </div>
      </div>
    </div>
    <v-client-table
      :data="planMedia.evenements"
      :columns="columns"
      :options="options"
      class="displayNoneVuePagination mgt-20px">
      <div slot="selected" slot-scope="props">
        <b-checkbox
          v-model="props.row.selected"
          @input="updateLignes(props, 'selected')"
          class="mgt-5px">
        </b-checkbox>
      </div>
      <div slot="dateEvenement" slot-scope="props">
        {{ props.row.dateEvenement | formatDate }}
      </div>
      <div slot="gestionnaire" slot-scope="props">
        {{ getLibelleGestionnaire(props.row.commercialId) }}
      </div>
      <div slot="type" slot-scope="props">
        {{ getLibelleTypeEvenement(props.row.typeId) }}
      </div>
      <div slot="edit" slot-scope="props">
        <a @click="addOrEditLigne(props.row)">
          <b-icon icon="pencil-box-outline" type="is-success"/>
        </a>
      </div>
      <div slot="delete" slot-scope="props">
        <a @click="deleteLigne(props.index)">
          <b-icon icon="delete-forever" type="is-danger"/>
        </a>
      </div>
    </v-client-table>
    <b-modal
      v-model="popupAddEditEvenement"
      class="modal"
      has-modal-card>
      <pop-up-add-edit-evenement
        :evenement="currentEvenement"
        :plan-media="planMedia"/>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import { ACTION_DELETE } from '@/configuration/general/actionsConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import selecteurAction from '@/components/general/selecteurAction';
import PopUpAddEditEvenement from '@/components/planMedia/edition/p_addEditEvenement';
import messageErreur from '@/services/general/messageErreur';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import { columnsSplice } from '@/services/general/columns';
import moment from 'moment';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'PlanMediaEvenement',
  props: {
    planMedia: {
      type: Object,
      required: true,
    },
    detail: {
      type: Boolean,
    },
  },
  components: {
    selecteurAction,
    PopUpAddEditEvenement,
  },
  data() {
    return {
      isLoad: false,
      currentEvenement: null,
      popupAddEditEvenement: false,
      actions: [
        { action: ACTION_DELETE, translation: 'addEditPlanMedia.evenement.actions.remove' },
      ],
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    allIsSelected() {
      return this.getAllSelected.length === this.planMedia.evenements.length;
    },
    iconSelectTotal() {
      if (this.allIsSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          dateEvenement: this.$t('addEditPlanMedia.evenement.information.dateEvenement'),
          gestionnaire: this.$t('addEditPlanMedia.evenement.information.gestionnaire'),
          type: this.$t('addEditPlanMedia.evenement.information.type'),
          descriptif: this.$t('addEditPlanMedia.evenement.information.descriptif'),
          ventes: this.$t('addEditPlanMedia.evenement.information.ventes'),
          edit: '',
          delete: '',
          selected: (h) => {
            return h(
              'a',
              {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    const allSelected = this.allIsSelected;
                    this.planMedia.evenements.forEach(c => {
                      c.selected = !allSelected;
                    });
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        columnsClasses: {
          edit: 'colonneSelected',
          delete: 'colonneSelected',
          selected: 'colonneSelected',
        },
        sortable: ['dateEvenement', 'gestionnaire', 'type', 'descriptif', 'ventes'],
      };
    },
    columns() {
      const columns = ['selected', 'dateEvenement', 'gestionnaire', 'type', 'descriptif', 'ventes', 'edit', 'delete'];
      if (this.detail) {
        columnsSplice(columns, 'selected');
        columnsSplice(columns, 'edit');
        columnsSplice(columns, 'delete');
      }
      return columns;
    },
    getAllSelected() {
      return this.planMedia.evenements.filter(c => c.selected);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametres: 'loadParametres',
    }),
    getLibelleGestionnaire(id) {
      const find = this.parametre(PARAMETRES_KEYS.utilisateur)
        .find((el) => el.id === id);
      if (find) return nomPrenomGetter(find);
      return '';
    },
    getLibelleTypeEvenement(id) {
      const find = this.parametre(PARAMETRES_KEYS.typeEvenement)
        .find((el) => el.id === id);
      if (find) return find.libelle;
      return '';
    },
    addOrEditLigne(evenement = null) {
      this.currentEvenement = evenement;
      this.popupAddEditEvenement = true;
    },
    updateLignes(props, key) {
      const ligneFind = this.planMedia.evenements[props.index - 1];
      if (ligneFind) this.$set(ligneFind, key, props.row[key]);
    },
    deleteLigne(propsIndex) {
      this.planMedia.evenements.splice(propsIndex - 1, 1);
    },
    handleAction(type) {
      switch (type) {
        case ACTION_DELETE:
          if (!this.allIsSelected) {
            this.getAllSelected.forEach(el => {
              const index = this.planMedia.evenements.indexOf(el);
              if (index !== -1) this.deleteLigne(index + 1);
            });
          } else this.planMedia.evenements = [];
          break;
        default:
          break;
      }
    },
  },
  async mounted() {
    this.isLoad = false;
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.typeEvenement]);
      await this.loadParametreUtilisateur();
      this.planMedia.evenements.sort((a, b) => {
        if (moment(a.dateEvenement)
          .isAfter(moment(b.dateEvenement))) return -1;
        if (moment(a.dateEvenement)
          .isSame(moment(b.dateEvenement))) return 0;
        return 1;
      });
      this.isLoad = true;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
